import React from "react";
import { useTranslation } from 'react-i18next';
import styles from "./css/TransportationTab.module.css";
import { CityAttributes, Favorites } from "@/types";
import { GraphsCard } from "@/components/cards/GraphsCard";
import { SimpleYearComparisonChart } from "@/components/graphs/SimpleYearComparisonGraph";
import { ChargingBarsGraphCity } from "@/components/graphs/ChargingBarsGraphCity";
import { ChargingPowerGraphCity } from "@/components/graphs//ChargingPowerGraphCity";
interface TransportationTabProps {
  favorites: Favorites;
  setFavorites: (favorites: Favorites) => void;
  cityAttributes: CityAttributes | null;
  colors: {
    vehicles: {
      [key: string]: string;
    };
    electric_vehicles: {
      [key: string]: string;
    };
    ev_charging_stations: {
      [key: string]: string;
    };
    charging_providers: {
      [key: string]: string;
    };
  };
}

export const TransportationTab: React.FC<TransportationTabProps> = ({ favorites, setFavorites, cityAttributes, colors }) => {
  const { t } = useTranslation('TransportationTab');
  const setFavourite = (id: string, isFavourite: boolean) => {
    setFavorites({ ...favorites, [id]: isFavourite });
  };

  return (
    <div className={styles.container}>
      <GraphsCard 
        title={t('vehicles')}
        children={<SimpleYearComparisonChart data={cityAttributes?.vehicles_count_dict} />} 
        setFavourite={setFavourite} 
        isFavourite={favorites?.vehicles ?? false} 
        id="vehicles"
      />

      <GraphsCard 
        title={t('electricVehicles')}
        children={<SimpleYearComparisonChart data={cityAttributes?.electric_vehicles_count_dict} />} 
        setFavourite={setFavourite} 
        isFavourite={favorites?.numberOfElectricVehicles ?? false} 
        id="numberOfElectricVehicles"
        disclaimer={{
          text: t('allElectricDisclaimer'),
          type: "info"
        }}
      />
      <GraphsCard 
        title={t('chargingStations')}
        children={
            <ChargingBarsGraphCity 
                data={cityAttributes?.ev_charging_stations_count} 
                size="normal"
            />
        } 
        id="chargingStations"
        setFavourite={setFavourite}
        isFavourite={favorites?.chargingStations ?? false}
      />

      <GraphsCard 
        title={t('chargingProviders')}
        children={<ChargingPowerGraphCity data={cityAttributes?.charging_providers} />} 
        setFavourite={setFavourite} 
        isFavourite={favorites?.existingCapacity ?? false} 
        id="existingCapacity"
      />
    </div>
  );
};
